import { declareVconsoleComponent } from '/vodalys/vvuejs/declareVconsoleComponent.mjs'
 
import Vform17Textfield2 from './Vform17Textfield2.vue' 

declareVconsoleComponent('vform17Textfield2', Vform17Textfield2, 'vform17_textfield2:component')